<script lang="ts">
  import Tag from '$shared/atoms/Tag/Tag.svelte';
  import { TagSize } from '$shared/constants/TagSize';
  import { TagTypes } from '$shared/atoms/Tag/TagProp';
  import type SearchProvider from '$provider/models/SearchProvider';

  interface Props {
    result: SearchProvider;
    onclick?: (e: MouseEvent) => void;
  }

  let { result, onclick }: Props = $props();
</script>

<button class="search-list-i" {onclick}>
  <div class="main-label">
    <div class="label">{result.label}</div>
    {#if result.activeStatus}
      <div class="label-tag">
        <Tag type={TagTypes.Greyed} size={TagSize.XSmall}>
          <div class="text">{result.activeStatus}</div>
        </Tag>
      </div>
    {/if}
  </div>
  {#if result.description}
    <p class="desc">{result.description}</p>
  {/if}
</button>

<style>
  .search-list-i {
    width: 100%;
    padding: 16px;
    border-bottom: 1px solid #e6e6e6;
    cursor: pointer;
    text-align: left;
  }
  .main-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .search-list-i:hover {
    background-color: var(--grey-bg);
  }
  .search-list-i .label {
    font-size: 14px;
    font-weight: 600;
    color: var(--grey-dark);
  }
  :global(.main-label .label-tag .comp-tag) {
    min-width: unset;
  }
  .search-list-i .main-label .label .text {
    font-size: 11px;
  }
  .search-list-i .desc {
    font-size: 11px;
    font-weight: normal;
    margin-top: 2px;
    color: var(--grey-medium);
  }
</style>
